import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { placeholderMap } from '../constants/placeholder';
import {
  AllFilterPointType,
  FilterNameMapButtonId,
} from '@op/operationLog/pages/filter';
import { FilterKeys } from '../types';
import * as CryptoJS from 'crypto-js';

const filterKeys: Set<string | undefined> = new Set();
let id: string | undefined = undefined;
export function addFilterBuriedPoint(key?: AllFilterPointType, value?: any) {
  if (!key) return;
  const placeholder = placeholderMap[key as FilterKeys]?.['en-US'] || key;
  const filterId = FilterNameMapButtonId[key];
  filterKeys.add(filterId);
  buriedBtnPoint(key, { filterName: placeholder, id, value });
}

export function setFilterPointLinkId() {
  const text = new Date().toString() + Math.random();
  const md5 = CryptoJS.MD5(text).toString();
  id = md5;
}

export function clearFilterBuriedPoint() {
  setFilterPointLinkId();
  filterKeys.clear();
}

export function addSubmitBuriedPoint() {
  buriedBtnPoint('FilterSubmit', {
    filterList: Array.from(filterKeys).join(','),
    id,
  });
  clearFilterBuriedPoint();
}

export function addHistoryBuriedPoint() {
  buriedBtnPoint('HistoryFilter');
}
